import { render, staticRenderFns } from "./guest_info.vue?vue&type=template&id=67fb35c9&scoped=true&"
import script from "./guest_info.vue?vue&type=script&lang=js&"
export * from "./guest_info.vue?vue&type=script&lang=js&"
import style0 from "./guest_info.vue?vue&type=style&index=0&id=67fb35c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fb35c9",
  null
  
)

export default component.exports